var map = {
	"./1-wrong.png": 7747,
	"./2-wrong.png": 4943,
	"./3-wrong.png": 978,
	"./4-wrong.png": 7309,
	"./5-wrong.png": 815,
	"./6-wrong.png": 3052,
	"./7-wrong.png": 9065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4234;